export const STORAGE_KEYS = {
  API_KEY: 'activity-stream-api-key',
  API_KEYS: 'activity-stream-api-keys',
  ACTIVE_KEY_ID: 'activity-stream-active-key-id',
}

export const validateApiKey = (key) => {
  const trimmed = (key ?? '').trim()

  if (!trimmed) {
    return { valid: false, message: '⚠️ API key is required.' }
  }

  if (!trimmed.startsWith('key-')) {
    return {
      valid: false,
      message: '⚠️ Invalid format. Expected key-[64 hex characters].',
      hint: 'API keys start with "key-" followed by 64 hexadecimal characters.',
    }
  }

  const hash = trimmed.slice(4)
  if (hash.length !== 64) {
    return {
      valid: false,
      message: `⚠️ Hash must be exactly 64 characters (got ${hash.length}).`,
      hint: 'Check if you copied the complete key.',
    }
  }

  if (!/^[a-f0-9]+$/.test(hash)) {
    return {
      valid: false,
      message: '⚠️ Hash contains invalid characters.',
      hint: 'Hash must only contain lowercase letters a-f and digits 0-9.',
    }
  }

  return { valid: true, message: '✓ Valid API key format.' }
}

export const maskKeyPreview = (value) => {
  if (!value) {
    return ''
  }
  if (value.length <= 12) {
    return value
  }
  return `${value.slice(0, 8)}…${value.slice(-4)}`
}

export const formatLastUsed = (isoString) => {
  if (!isoString) {
    return 'Never'
  }
  const date = new Date(isoString)
  if (Number.isNaN(date.getTime())) {
    return 'Unknown'
  }
  const now = Date.now()
  const diffMs = now - date.getTime()
  const minutes = Math.floor(diffMs / 60000)
  if (minutes < 1) {
    return 'Just now'
  }
  if (minutes < 60) {
    return `${minutes}m ago`
  }
  const hours = Math.floor(minutes / 60)
  if (hours < 24) {
    return `${hours}h ago`
  }
  const days = Math.floor(hours / 24)
  return `${days}d ago`
}

export const normalizeStoredKey = (entry) => ({
  id: entry.id ?? (typeof crypto !== 'undefined' && crypto.randomUUID ? crypto.randomUUID() : `key-${Date.now()}`),
  label: entry.label ?? 'Untitled',
  apiKey: entry.apiKey ?? entry.key ?? '',
  writeKey: entry.writeKey ?? '',
  lastUsed: entry.lastUsed ?? null,
  partition: entry.partition ?? null,
  region: entry.region ?? null,
})
